import { cn } from '@/lib/utils';

export interface SaveDraftProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
  'aria-label'?: string;
}

/**
 * SaveDraft icon — exact SVG from Figma design (node 4894-5640).
 * Represents a rounded document/container outline with a centered
 * downward arrow and top-slot accent bar.
 * Do NOT replace with Lucide Archive/Inbox — path is custom.
 */
export function SaveDraft({
  size = 14,
  width,
  height,
  fill = 'currentColor',
  className,
  'aria-label': ariaLabel,
  ...props
}: SaveDraftProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 14 14"
      fill="none"
      className={cn('inline-block flex-shrink-0 transition-colors', className)}
      role={ariaLabel ? 'img' : 'presentation'}
      aria-label={ariaLabel}
      aria-hidden={!ariaLabel}
      {...props}
    >
      <path
        d="M6.75 11.25L9.75 8.25L8.7 7.2L7.5 8.4V5.25H6V8.4L4.8 7.2L3.75 8.25L6.75 11.25ZM1.5 3.75V12H12V3.75H1.5ZM1.5 13.5C1.0875 13.5 0.73125 13.3563 0.43125 13.0688C0.14375 12.7688 0 12.4125 0 12V2.64375C0 2.46875 0.0250002 2.3 0.0750003 2.1375C0.1375 1.975 0.225 1.825 0.3375 1.6875L1.275 0.54375C1.4125 0.36875 1.58125 0.2375 1.78125 0.15C1.99375 0.05 2.2125 0 2.4375 0H11.0625C11.2875 0 11.5 0.05 11.7 0.15C11.9125 0.2375 12.0875 0.36875 12.225 0.54375L13.1625 1.6875C13.275 1.825 13.3563 1.975 13.4062 2.1375C13.4688 2.3 13.5 2.46875 13.5 2.64375V12C13.5 12.4125 13.35 12.7688 13.05 13.0688C12.7625 13.3563 12.4125 13.5 12 13.5H1.5ZM1.8 2.25H11.7L11.0625 1.5H2.4375L1.8 2.25Z"
        fill={fill}
      />
    </svg>
  );
}
